/* eslint no-console:0 */

require('components/common_components');
require('minimal/home');